/**
 * Asynchronously loads the component for StudentJobDetail
 */

import { lazyLoad } from "utils/loadable";

export const StudentJobDetail = lazyLoad(
  () => import("./index"),
  (module) => module.StudentJobDetail
);
